import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isClientPortalUser, isSupplierPortalUser } from '../lib/permissions';

/**
 * ISSUE-143: el árbol de rutas interno (`Layout`, sidebar, todo lo que no
 * es un portal) nunca debe renderizarse para un rol externo — es la
 * contraparte explícita de `ClientPortalRoute` y `SupplierPortalRoute`.
 */
export function InternalRoute() {
  const { user } = useAuth();
  if (isSupplierPortalUser(user)) return <Navigate to="/proveedor" replace />;
  return isClientPortalUser(user) ? <Navigate to="/portal" replace /> : <Outlet />;
}
